module.exports = __webpack_public_path__ + "assets/df9e56bff084de511fb64c1324de6152.png";